<!--
 * @Author: wjc
 * @Date: 2023-11-15 09:54:21
 * @LastEditors: wjc
 * @LastEditTime: 2026-08-12 10:00:00
 * @Description: 应用根组件
-->
<template>
  <nuxt-layout>
    <nuxt-page />
  </nuxt-layout>
  <client-only><toast-container /></client-only>
</template>

<script setup lang="ts">
  import { themeVar } from '~/utils/colors'
  import { updateMainColorVariables } from '~/utils/css-var'

  onBeforeMount(() => {
    updateMainColorVariables(themeVar)
  })
</script>

<style lang="scss">
  html,
  body,
  /* stylelint-disable-next-line selector-id-pattern */
  #__nuxt {
    height: 100%;
    padding: 0;
    margin: 0;
  }
</style>
